import type {ReactElement} from 'react';
import {useContext} from 'react';
import {Dropdown} from '@Components/dropdown-v2';
import {ALIGNMENT_TYPE} from '@Components/dropdown-v2/dropdown.types';
import {ControlledList} from '@Components/controlled-list';
import type {ControlledListItemType} from '@Components/controlled-list/controlled-list.types';
import {CONTROLLED_LIST_ITEM_TYPE} from '@Components/controlled-list/controlled-list.types';
import {Icon} from '@Components/icon-v2';
import {IconShape, IconSize, IconType} from '@Components/icon-v2/icon.types';
import {formMakerContext} from '@FormMakerReact/form-maker.context';
import {EditorViewport} from '@FormMakerReact/form-maker.types';
import {HELP_CENTER_URL, HelpMenuOption} from './help-button.types';
import styles from './help-button.module.scss';

export function HelpButton(): ReactElement | null {
  const {state, actions} = useContext(formMakerContext);
  if (state.editorViewport === EditorViewport.MOBILE) {
    return null;
  }
  const isDesktop = state.editorViewport === EditorViewport.DESKTOP;

  const onClick = (id?: string): void => {
    if (id === HelpMenuOption.HELP_CENTER) {
      window.open(HELP_CENTER_URL, '_blank', 'noopener');
      return;
    }
    if (id === HelpMenuOption.KEYBOARD_SHORTCUTS) {
      actions.openRightPanelKeyboardShortcuts();
    }
  };

  return <Dropdown selector={renderSelector()} popup={<ControlledList items={getMenuItems(isDesktop)} onClick={onClick} />} alignment={ALIGNMENT_TYPE.BOTTOM_END} popUpHasCustomWidth popupClassName={styles.popup} />;
}

function renderSelector(): ReactElement {
  return <Icon icon="icon-help" type={IconType.DARK_GHOST} shape={IconShape.SQUARE} size={IconSize.SIZE_ICON_20} ariaLabel={window.i18next.t('pmwjs_help_center')} />;
}

function getMenuItems(isDesktop: boolean): ControlledListItemType[] {
  const items: ControlledListItemType[] = [
    {
      id: HelpMenuOption.HELP_CENTER,
      icon: 'icon-help',
      text: window.i18next.t('pmwjs_help_center'),
      type: CONTROLLED_LIST_ITEM_TYPE.DEFAULT_7,
    },
  ];
  if (isDesktop) {
    items.push({
      id: HelpMenuOption.KEYBOARD_SHORTCUTS,
      icon: 'icon-keyboard',
      text: window.i18next.t('pmwjs_keyboard_shortcuts'),
      type: CONTROLLED_LIST_ITEM_TYPE.DEFAULT_7,
    });
  }
  return items;
}
